import { render } from "./BrandBox.vue?vue&type=template&id=18765b7f&scoped=true"
import script from "./BrandBox.vue?vue&type=script&lang=js"
export * from "./BrandBox.vue?vue&type=script&lang=js"

import "./BrandBox.vue?vue&type=style&index=0&id=18765b7f&scoped=true&lang=css"

import exportComponent from "C:\\workspace\\vue\\bxt4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18765b7f"]])

export default __exports__